import { Component, OnInit, TemplateRef, ViewEncapsulation, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { SettingsService } from '../../../../services/settings.service';
import { GeneralService } from '../../../../services/general.service';

//import classes
import {
  SettingsFormMangIn, SettingsFormMangOut
} from '../../../../classes/settings.model';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

declare var CKEDITOR: any;
declare var $: any;

@Component({
  selector: 'app-sub-form',
  templateUrl: './sub-form.component.html',
  styleUrls: ['./sub-form.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SubFormComponent implements OnInit {

  @ViewChild('FormMangModal') FormMangModal: ElementRef;
  @ViewChild('FormMangViewModal') FormMangViewModal: ElementRef;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  @ViewChildren('background_exists') backgroundImageDiv: ElementRef;
  
  FormMangForm: FormGroup;
  FormMangFormSubmitted: Boolean = false;
  FormMangFormErrorMsg: any;
  
  details: any;
  listLang: any;
  listResp: any;
  editLang: any;
  editResp: any;

  
  imageLink: any;
  dtOptions: any;
  modalRef: BsModalRef;
  imagePreviewModal: BsModalRef;
  ckeditor_config: any;
  ckeditor_clicked = false;
  backgroundDiv = true;
  pdfSrc: any;

  constructor(
    private route: ActivatedRoute,
    private settingsService: SettingsService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    // public bsModalRef: BsModalRef,
    private router: Router,
  ) { }

  ngOnInit() {

    //load data
    this.dataLoad();

    //load datatable
    this.dtLoad();

    //load ckeditor
    this.ckeditor();
  }

  dataLoad(): void {

    //fetch data from service
    this.details = this.route.snapshot.data['data'];

    //load list data
    this.listLang = this.settingsService.getlistLangForm(this.details);
    this.listResp = this.details.data.formsData;

    //load edit data
    this.editLang = this.settingsService.getEditLangForm(this.details);

  }

  FormMangClick(event): void {

    var target = event.currentTarget;

    let action = target.dataset.action;
    let sectionId = target.dataset.section;
    let titleId = target.dataset.title;

    let input: any = { action: action, section_id: sectionId, title_id: titleId };

    this.FormMangServCall(input);

  }

  FormMangServCall(input: SettingsFormMangIn): void {

    this.settingsService.FormMangServCall(input)
      .subscribe(
        res => {

          if(input.action == 'edit')
            this.FormMangEdit(res);
          else if(input.action == 'view')
            this.FormMangView(res);
          else if(input.action == 'reload')
            this.FormMangReload(res);

        }
      );

  }

  FormMangEdit(res): void{

    this.editResp = res.data.details;

    this.FormMangBuild();
    
    this.modalRef = this.modalService.show(this.FormMangModal, { class: 'modal-lgs' });
    
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });

  }

  // FormMangView(res): void{

  //   this.pdfSrc = this.FormMangModal;

  //   this.modalRef = this.modalService.show(this.FormMangViewModal, { class: 'modal-lgs' });
  // }

  FormMangView(res): void{

    var file = new Blob([res], { type: 'application/pdf' });            
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
    
  }

  FormMangReload(res): void{

    if (res.status)
      this.generalService.notify_msg('success', res.msg);
    else
      this.generalService.notify_msg('error', res.msg);  
    
  }
  
  FormMangBuild(): void {

    this.FormMangForm = this.formBuilder.group({
      section_title: [{value: this.editResp.section_title, disabled: true}],
      title: [{value: this.editResp.title, disabled: true}],
      orientation: [this.editResp.orientation],
      background: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]],
      background_img: [''],
      background_exists_full: [{value: this.editResp.background, disabled: true}],
      background_exists: [this.editResp.background.split('/').pop()],
      html_body: [this.editResp.html_body, [Validators.required]],
      section_id: [this.editResp.section_id],
      title_id: [this.editResp.title_id],
      action: 'update'
    });

    this.FormMangFormErrorMsg = {
      'background': [
        { type: 'validExt', message: 'File format is not supported' }
      ],
      'html_body': [{ type: 'required', message: 'This field is Required' }],
    }

  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  dtLoad(): void {
    this.dtOptions = {
      paging: false,
      bAutoWidth: false,
    };
  }

  ckeditor(): void {
    
    this.ckeditor_config = {
      plugins: 'dialogui,dialog,a11yhelp,dialogadvtab,basicstyles,bidi,blockquote,notification,button,toolbar,clipboard,panelbutton,panel,floatpanel,colorbutton,colordialog,templates,menu,contextmenu,copyformatting,div,resize,elementspath,enterkey,entities,popup,filetools,filebrowser,find,fakeobjects,flash,floatingspace,listblock,richcombo,font,format,horizontalrule,htmlwriter,iframe,wysiwygarea,image,indent,indentblock,indentlist,smiley,justify,menubutton,language,link,list,liststyle,magicline,maximize,newpage,pagebreak,pastetext,pastefromword,preview,removeformat,save,selectall,showblocks,showborders,sourcearea,specialchar,scayt,stylescombo,tab,table,tabletools,tableselection,undo,lineutils,widgetselection,widget,notificationaggregator,uploadwidget,uploadimage,wsc',
      div_wrapTable: true,
      extraPlugins: 'tableresize',
      height: 350,
      filebrowserBrowseUrl: 'http://localhost:8081/projects/kaizen/assets/plugins/ckfinder/ckfinder.html',
      filebrowserImageBrowseUrl: 'http://localhost:8081/projects/kaizen/assets/plugins/ckfinder/ckfinder.html?Type=Images',
      filebrowserUploadUrl: 'http://localhost:8081/projects/kaizen/assets/plugins/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files',
      filebrowserImageUploadUrl: 'http://localhost:8081/projects/kaizen/assets/plugins/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Images',
      filebrowserWindowWidth: '1000',
      filebrowserWindowHeight: '700',
    };

  }

  ckeditorOnFocus() {
    this.ckeditor_clicked = true;
  }

  ckeditorOnBlur() {
    this.ckeditor_clicked = false;
  }

  ckeditorInsert(value) {

    if(this.ckeditor_clicked)
      CKEDITOR.instances.editor1.insertHtml('{{{'+value+'}}}')

  }

  imagePreview(value) {

    this.imageLink = value;
    this.imagePreviewModal = this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }

  updateForm() {

    this.FormMangFormSubmitted = true;

    if (this.FormMangForm.invalid)
      return;

    // console.log('submitted');
    // console.log(this.FormMangForm.value);
    // return;
    
    this.settingsService.FormMangUpdate(this.FormMangForm.value)
      .subscribe(
        (res) => {

          if (res.status) {
            this.generalService.notify_msg('success', res.msg);
            $('.splash').modal('hide');
            this.modalRef.hide();

            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SETTINGS]);
              });
          }
          else
            this.generalService.notify_msg('error', res.msg);
        }
      );

  }


  BackgroundImageChange(event) {
    this.fileChange(event, this.FormMangForm, 'background', 'background_img');
  }

  BackgroundImageRemove() {
    this.FormMangForm.controls['background_exists'].reset();
    this.backgroundDiv = false;
  }

  fileChange(event, form, source, target) {

    form.get(target).patchValue('');

    let reader = new FileReader();
    if (event.target.files && event.target.files.length) {

      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (form.get(source).valid) {
          form.get(target).patchValue(reader.result);
        }
      };

    }
  }


}
